export const language = {
    hu: {
      week: 'Hét',
      work_week: 'Munkahét',
      day: 'Nap',
      month: 'Hónap',
      previous: 'Előző',
      next: 'Következő',
      today: `Ma`,
      agenda: 'Napirend',
      date: 'Dátum',
      time: 'Idő',
      event: 'Esemény',
      allDay: 'Egész nap',
      noEventsInRange : 'Nincs esemény ebben az intervallumban.',
      showMore: (total) => `+${total} plus`,
      search: 'keresés...'
    }
  };